function init() {

    // message close handler
    $("a.close").click(function () {
        hideMessage();
    });
    $("#close-cookies").click(function () {
        hideMessage();
    });
    $("#accept-cookies").click(function () {
        $.cookie("accepts-cookies", "true", { expires: 365, path: "/" });
        hideMessage();
    });

    // approval button handler
    $("button.approval").click(function () {
        $.cookie("accepts-cookies", "true", { expires: 365, path: "/" });
        hideMessage();
    });

}

function hideMessage() {
    $(".cookie-message-container").slideUp("slow");
}

export default {
    init
}